import { Rule } from "antd/es/form";

export const stringValidation = (
  name?: string,
  message?: string,
  required: boolean = true,
  min: number = 2,
  max: number = 50
): Rule[] => [
    {
      required,
      message: message || `Please enter your ${name}`,
    },
    {
      type: "string",
      min,
      message: message || `${name} must be at least 2 characters`,
    },
    {
      type: "string",
      max,
      message: message || `${name} must be at most 50 characters`,
    },
    {
      pattern: /^[a-zA-Z\s]*$/,
      message: message || `${name} can only contain letters and spaces`,
    },
  ];

export const numberValidation = (
  name?: string,
  message?: string,
  required: boolean = true,
  zeroValidation: boolean = false,
  max1?: number,
  maxMessage1?: string,
  max2?: number,
  maxMessage2?: string,

): Rule[] => [
    {
      required,
      message: message || `Please enter a ${name}`,
    },
    {
      validator: (_, value) => {
        if (value !== undefined && value !== null && value !== "") {
          if (!/^[\d,.]+$/.test(value)) {
            return Promise.reject("Only numeric values, commas, and dots are allowed");
          }

          const num = parseInt(value, 10);

          if (zeroValidation && num <= 0) {
            return Promise.reject("Value must be greater than zero");
          }

          if (max1 !== undefined && num > max1) {
            return Promise.reject(
              maxMessage1 || "Value must be less than total quantity"
            );
          }
          if (max2 !== undefined && num > max2) {
            return Promise.reject(
              maxMessage2 || "Value must be less than total quantity"
            );
          }
        }
        return Promise.resolve();
      },
    },
  ];

export const phoneNumberValidation = (
  message?: string,
  required: boolean = true
): Rule[] => [
    { required: required, message: message || `Please enter a phone number` },
    {
      pattern: /^[6-9]\d{9}$/,
      message: "Enter a valid 10-digit Indian phone number",
    },
  ];
